import { useCallback, useEffect, useState } from 'react';
/** The search debounce time in milliseconds. */
const searchDebounceTime = 300;
/**
 * Represents the hook for handling search in a conversations filter that relies
 * on a paginated endpoint.
 */
export function useConversationsPaginatedFilterSearch({ arg, changeArg, }) {
    const [search, setSearch] = useState({});
    /** Handles searching the items in the dropdown select. */
    const handleSearch = useCallback((value) => {
        setSearch({ term: (value === null || value === void 0 ? void 0 : value.trim()) || undefined });
    }, []);
    /** Handles when the dropdown open state is toggled. */
    const handleToggle = useCallback((isOpen) => {
        if (!isOpen) {
            setSearch({});
        }
    }, [setSearch]);
    // Changes the arg when search term changes.
    useEffect(() => {
        var _a;
        if (search.term !== (arg === null || arg === void 0 ? void 0 : arg.searchTerm)) {
            changeArg({
                searchTerm: search.term,
                offset: undefined,
                limit: undefined,
            }, { debounceTime: (_a = search === null || search === void 0 ? void 0 : search.debounceTime) !== null && _a !== void 0 ? _a : searchDebounceTime });
        }
        // Don't rely on arg as dependency because we change the arg inside.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [changeArg, search]);
    return {
        search,
        handleToggle,
        handleSearch,
    };
}
